import { } from '@/api/requests';
import router from '../../router';

const state = {
  createExercise: false,
  viewExerciseDetails: false,
  selectedExercise: {},
  editExercise: {},
};

const mutations = {
  updateAttribute(state, payload) {
    state[payload.type] = payload.value;
  },

  setSelectedExercise(state, exercise) {
    state.selectedExercise = exercise;
    state.viewExerciseDetails = true;
  },

  clearSelectedExercise(state) {
    state.selectedExercise = null;
    state.viewExerciseDetails = false;
  },

  setEditExercise(state, exercise) {
    state.editExercise = exercise;
    state.createExercise = true;
    state.selectedExercise = null;
    state.viewExerciseDetails = false;
  },

  closeEditExercise(state) {
    state.editExercise = {};
    state.createExercise = false;
    state.selectedExercise = {};
    state.viewExerciseDetails = false;
  }
};

const actions = {
  exerciseClicked(context, exercise) {
    context.commit('setSelectedExercise', exercise);
  },

  editExerciseClicked(context, exercise) {
    context.commit('setEditExercise', exercise);
  },

  closeExerciseModal(context) {
    context.commit('closeEditExercise');
  },

  exerciseDetailsClosed(context) {
    context.commit('clearSelectedExercise');
  },
};

const getters = {

};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};